export const checkoutOrderConfirmation = {
  checkoutOrderConfirmation: {
    confirmationOfOrder: 'Confirmation of Order:',
    thankYou: 'Thank you for your order!',
    invoiceHasBeenSentByEmail: 'An invoice has been sent by email. You should receive it soon.',
    orderItems: 'Order Items',
    orderPlacedSuccessfully: 'Order placed successfully',
    createAccount: 'Create an account?',
    createAccountForNext: 'Create an account for <{{email}}> for a faster checkout on your next visit.',
    replenishmentNumber: 'Replenishment #',
    placedOn: 'Order Creation Date',
    methodOfPayment: 'Method of Payment',
    shippingMethod: 'Delivery Mode',
    purchaseOrderNumber: 'Purchase Order Number',
    status: 'Order Status',
    active: 'Active',
    cancelled: 'Cancelled',
    frequency: 'Frequency',
    nextOrderDate: 'Next order date',
    orderNumber: 'Order Number',
    orderTotal: 'Order Total',
    totalQuantity: 'Total Quantity',
    totalItems: 'Total Items',
    orderType: 'Order Type',
    jobName: 'Job Name',
    placedBy: 'Order Placed By',
    soldTo: 'Sold To',
    reqDeliveryDate: 'Requested Delivery Date',
    copyHasBeenSentToEmail: 'A copy of this page has been emailed to you at ',
    contractor: 'Contractor',
  },
};
